package com.raouf.mehrguard.web.i18n

internal val TurkishStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Kotlin Multiplatform QRishing Dedektörü",
    WebStringKey.MenuMain to "Ana Menü",
    WebStringKey.MenuSecurity to "Güvenlik",
    WebStringKey.MenuSystem to "Sistem",
    WebStringKey.NavDashboard to "Gösterge Paneli",
    WebStringKey.NavScanMonitor to "Tarama Monitörü",
    WebStringKey.NavScanHistory to "Tarama Geçmişi",
    WebStringKey.NavTrustCentre to "Güven Merkezi",
    WebStringKey.NavReports to "Raporlar",
    WebStringKey.NavTraining to "Eğitim",
    WebStringKey.NavSettings to "Ayarlar",
    WebStringKey.QuickActions to "Hızlı İşlemler",

    // Hero Section
    WebStringKey.HeroTagline to "Güvenli. Çevrimdışı.",
    WebStringKey.HeroTagline2 to "Açıklanabilir Savunma.",
    WebStringKey.HeroDescription to "Mehr Guard potansiyel tehditleri doğrudan donanımınızda analiz eder. Sıfır gecikme korumasını deneyimleyin.",

    // Dashboard
    WebStringKey.StartScan to "Yeni Tarama Başlat",
    WebStringKey.ImportImage to "Görsel İçe Aktar",
    WebStringKey.ScanQrCode to "QR Kodu Tara",
    WebStringKey.SystemHealth to "Sistem Durumu",
    WebStringKey.ThreatDatabase to "Tehdit Veritabanı",
    WebStringKey.Current to "Güncel",
    WebStringKey.Active to "Aktif",
    WebStringKey.Threats to "Tehditler",
    WebStringKey.SafeScans to "Güvenli Taramalar",
    WebStringKey.EngineActive to "Motor Aktif",
    WebStringKey.EnterpriseProtection to "Kurumsal Koruma Aktif",
    WebStringKey.SystemOptimal to "Sistem Optimal",
    WebStringKey.EngineStatus to "Motor v2.4 • 2s önce güncellendi",
    WebStringKey.ThreatsBlocked to "Engellenen Tehditler",
    WebStringKey.AllSystemsOperational to "Tüm sistemler çalışıyor",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Genel Bakış",
    WebStringKey.SectionSecurity to "Güvenlik",
    WebStringKey.SectionTraining to "Eğitim",
    WebStringKey.SectionReports to "Raporlar",
    WebStringKey.OfflineReady to "Çevrimdışı Hazır",
    WebStringKey.OfflineDescription to "Yerel veritabanı v2.4.1 aktif. Bu cihazdan veri çıkmaz.",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "Güven Merkezi",
    WebStringKey.OfflineGuarantee to "Katı Çevrimdışı Garantisi",
    WebStringKey.OfflineGuaranteeDesc to "Mehr Guard analizi tamamen cihazınızın Neural Engine'inde çalışır. URL verileri asla telefonunuzdan çıkmaz.",
    WebStringKey.ThreatSensitivity to "Tehdit Hassasiyeti",
    WebStringKey.ResetConfirm to "Bu, tüm Güven Merkezi ayarlarını varsayılanlara sıfırlayacaktır.",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Tehdit Monitörü",
    WebStringKey.ThreatMonitorDesc to "Canlı tehditleri görüntüle ve güvenlik denetimi çalıştır",
    WebStringKey.TrustCentreDesc to "Gizlilik ayarları ve tehdit hassasiyeti",
    WebStringKey.ExportReport to "Raporu Dışa Aktar",
    WebStringKey.ExportReportDesc to "PDF veya JSON güvenlik raporu oluştur",

    // Dashboard Content
    WebStringKey.Analyze to "Analiz Et",
    WebStringKey.HeuristicEngine to "Sezgisel Motor",
    WebStringKey.HighPerformanceEngine to "Yüksek Performanslı Motor",
    WebStringKey.RecentScans to "Son Taramalar",
    WebStringKey.ViewFullHistory to "Tam Geçmişi Görüntüle",
    WebStringKey.Status to "Durum",
    WebStringKey.Source to "Kaynak",
    WebStringKey.Details to "Ayrıntılar",
    WebStringKey.Time to "Zaman",
    WebStringKey.Version to "Sürüm",
    WebStringKey.LastUpdate to "Son Güncelleme",
    WebStringKey.Signatures to "İmzalar",
    WebStringKey.CheckForUpdates to "Güncellemeleri Kontrol Et",
    WebStringKey.FeatureOfflineTitle to "Çevrimdışı Öncelikli Mimari",
    WebStringKey.FeatureOfflineDesc to "Tam analiz yerel olarak gerçekleştirilir. Kamera akışınız ve taranan veriler asla harici bir sunucuya ulaşmaz, mutlak gizlilik sağlar.",
    WebStringKey.FeatureExplainableTitle to "Açıklanabilir Güvenlik",
    WebStringKey.FeatureExplainableDesc to "Sadece \"Engelle\" almayın. URL parametreleri, yönlendirmeler ve JavaScript yüklerinin ayrıntılı sezgisel analizlerini sunuyoruz.",
    WebStringKey.FeaturePerformanceDesc to "Masaüstü ortamları için optimize edildi. Taramalar yerel Kotlin Multiplatform ikili dosyaları kullanılarak 5ms'nin altında işlenir.",
    WebStringKey.TrainingCentre to "Eğitim Merkezi",
    WebStringKey.LearnHomograph to "Gelişmiş QR homograf saldırılarını nasıl tanımlayacağınızı öğrenin.",
    WebStringKey.BeatTheBotAction to "Botu Yen →",
    WebStringKey.NoScansYet to "Henüz tarama yok. Sonuçları görmek için yeni bir tarama başlatın.",
    WebStringKey.VerdictSafe to "GÜVENLİ",
    WebStringKey.VerdictPhish to "OLTALAMA",
    WebStringKey.VerdictWarn to "UYARI",
    WebStringKey.ScoreLabel to "Puan:",

    // Scanner
    WebStringKey.ActiveScanner to "Aktif Tarayıcı",
    WebStringKey.OfflineMode to "Çevrimdışı Mod",
    WebStringKey.LiveFeedDisconnected to "CANLI YAYIN BAĞLANTISI KESİLDİ",
    WebStringKey.CameraAccessRequired to "Kamera Erişimi Gerekli",
    WebStringKey.CameraAccessDescription to "Taramaya başlamak için buraya bir QR kod görseli sürükleyip bırakın veya kamera erişimini etkinleştirin.",
    WebStringKey.EnableCamera to "Kamerayı Etkinleştir",
    WebStringKey.Scanning to "Taranıyor...",
    WebStringKey.ScanHint to "Sabit tutun. <5ms'de çevrimdışı analiz edildi.",
    WebStringKey.Torch to "El Feneri",
    WebStringKey.Gallery to "Galeri",
    WebStringKey.PasteUrl to "URL Yapıştır",
    WebStringKey.PasteUrlTitle to "Analiz Edilecek URL Yapıştır",
    WebStringKey.AnalyzeUrl to "URL Analiz Et",
    WebStringKey.SystemStatus to "Sistem Durumu",
    WebStringKey.PhishingEngine to "Oltalama Motoru",
    WebStringKey.Ready to "HAZIR",
    WebStringKey.LocalDb to "Yerel DB",
    WebStringKey.Latency to "Gecikme",
    WebStringKey.ViewAll to "Tümünü Görüntüle",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Ana Sayfa",
    WebStringKey.BreadcrumbScans to "Taramalar",
    WebStringKey.OfflineProtection to "Çevrimdışı Koruma",
    WebStringKey.VerdictHighRisk to "YÜKSEK RİSK TESPİT EDİLDİ",
    WebStringKey.VerdictDangerous to "Tehlikeli",
    WebStringKey.VerdictDangerousDesc to "Taranan QR kodu, oltalama ve kimlik bilgisi toplama ile ilişkili kötü amaçlı göstergeler içeriyor. Hedef URL'ye devam etmeyin.",
    WebStringKey.ThreatConfidence to "Tehdit Güveni",
    WebStringKey.FlagPhishing to "Oltalama Girişimi",
    WebStringKey.FlagObfuscated to "Gizlenmiş Komut Dosyası",
    WebStringKey.FlagHomograph to "Homograf Saldırısı",
    WebStringKey.ClearHistory to "Tümünü Temizle",
    WebStringKey.SectionAttackBreakdown to "Saldırı Analizi",
    WebStringKey.AttackHomographTitle to "Homograf / IDN Saldırısı",
    WebStringKey.AttackHomographDesc to "Latin alfabesini taklit eden Kiril karakterleri tespit edildi.",
    WebStringKey.AttackVisualLabel to "Görsel Görünüm",
    WebStringKey.AttackPunycodeLabel to "Gerçek Punycode",
    WebStringKey.AttackHomographExplain to "Alan adı Latin 'a' (U+0061) yerine Kiril 'а' (U+0430) kullanıyor. Bu teknik genellikle kullanıcıları meşru bir hizmeti ziyaret ettiklerine inandırmak için kullanılır.",
    WebStringKey.AttackRedirectTitle to "Şüpheli Yönlendirme Zinciri",
    WebStringKey.AttackRedirectDesc to "Bilinen URL kısaltıcıları içeren 3 atlama tespit edildi.",
    WebStringKey.RedirectStart to "QR Kod Taraması",
    WebStringKey.RedirectHop to "Ara Atlama",
    WebStringKey.RedirectFinal to "Son Hedef",
    WebStringKey.AttackJsTitle to "Gizlenmiş JavaScript",
    WebStringKey.AttackJsDesc to "URL parametrelerinde yüksek entropi dizesi tespit edildi.",
    WebStringKey.SectionActions to "Önerilen İşlemler",
    WebStringKey.ActionBlock to "Engelle & Raporla",
    WebStringKey.ActionBlockDesc to "Erişimi engelle ve yöneticiyi bilgilendir",
    WebStringKey.ActionQuarantine to "Sandbox'ta Karantinaya Al",
    WebStringKey.ActionQuarantineDesc to "Analiz için güvenle aç",
    WebStringKey.Expected to "Beklenen: ",
    WebStringKey.Detected to "Tespit Edilen: ",
    WebStringKey.ExplainableSecurity to "Açıklanabilir Güvenlik",
    WebStringKey.UrlBreakdown to "URL ANALİZİ",
    WebStringKey.FullUrl to "TAM URL",
    WebStringKey.OpenInBrowser to "Tarayıcıda Aç (Riskli)",
    WebStringKey.OpenWarning to "Bu URL'yi tarayıcınızda açmak sizi güvenlik risklerine maruz bırakabilir.",
    WebStringKey.RestrictedMode to "Kısıtlı Mod",
    WebStringKey.RestrictedDesc to "Bu URL potansiyel olarak tehlikeli olarak işaretlendi. Devam etmeden önce aşağıdaki analizi inceleyin.",
    WebStringKey.DangerousWarning to "Bu URL potansiyel olarak tehlikeli olarak işaretlendi. Açmak sizi oltalama, kötü amaçlı yazılım veya diğer güvenlik tehditlerine maruz bırakabilir. Devam etmek istediğinizden emin misiniz?",
    WebStringKey.CopyUrl to "URL'yi Kopyala",
    WebStringKey.Share to "Paylaş",
    WebStringKey.Dismiss to "Kapat",
    WebStringKey.ReasonDomainAge to "Alan adı yaşı 24 saatten az.",
    WebStringKey.ReasonSignatures to "Yerel oltalama DB'sinde 3 imza eşleşti.",
    WebStringKey.ReasonAsn to "Hedef IP yüksek riskli bir ASN'de bulunuyor.",
    WebStringKey.SectionMeta to "Tarama Meta Verileri",
    WebStringKey.MetaTime to "Tarama Süresi",
    WebStringKey.MetaSource to "Kaynak",
    WebStringKey.MetaEngine to "Motor",
    WebStringKey.MetaOfflineGuaranteeLabel to "Çevrimdışı Garantisi:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Bu görsel cihazınızda yerel olarak analiz edildi. Bu karar için buluta veri gönderilmedi.",
    
    WebStringKey.ScanComplete to "Tarama Tamamlandı",
    WebStringKey.Loading to "Yükleniyor...",
    WebStringKey.AnalyzedOffline to "<5ms'de çevrimdışı analiz edildi",
    WebStringKey.NoDataLeaves to "Veri cihazdan çıkmaz",
    WebStringKey.ActiveProtection to "Aktif Koruma",
    WebStringKey.ConfidenceScore to "Güven Puanı",
    WebStringKey.Analyzing to "ANALİZ EDİLİYOR...",
    WebStringKey.ProcessingResults to "Tarama sonuçları işleniyor...",
    WebStringKey.RiskAssessment to "Risk Değerlendirmesi",
    WebStringKey.AnalysisTime to "Analiz Süresi",
    WebStringKey.Heuristics to "Sezgisel Analiz",
    WebStringKey.TopAnalysisFactors to "Başlıca Analiz Faktörleri",
    WebStringKey.Pass to "GEÇTİ",
    WebStringKey.Info to "BİLGİ",
    WebStringKey.Clean to "TEMİZ",
    WebStringKey.ValidSslCertificate to "Geçerli SSL Sertifikası",
    WebStringKey.SslCertificateDesc to "DigiCert Inc tarafından verilen sertifika",
    WebStringKey.EstablishedDomain to "Köklü Alan Adı",
    WebStringKey.EstablishedDomainDesc to "5+ yıl önce kayıtlı alan adı",
    WebStringKey.BlacklistStatus to "Kara Liste Durumu",
    WebStringKey.BlacklistStatusDesc to "52 yerel tehdit DB'sinde bulunamadı",
    WebStringKey.BackToDashboard to "Panele Dön",
    WebStringKey.ShareReport to "Raporu Paylaş",
    WebStringKey.CopyLink to "Bağlantıyı Kopyala",
    WebStringKey.LinkCopied to "Bağlantı panoya kopyalandı!",
    WebStringKey.BeatTheBot to "Botu Yen",
    WebStringKey.BeatTheBotDesc to "Çevrimdışı AI'mıza meydan oku",
    WebStringKey.SessionId to "Oturum ID",
    WebStringKey.EndSession to "Oturumu Bitir",
    WebStringKey.Round to "Tur",
    WebStringKey.BrowserPreview to "Tarayıcı Önizleme",
    WebStringKey.MakeDecision to "Kararını ver",
    WebStringKey.Phishing to "Oltalama",
    WebStringKey.Legitimate to "Meşru",
    WebStringKey.LiveHint to "Canlı İpucu",
    WebStringKey.LiveScoreboard to "Canlı Skor Tablosu",
    WebStringKey.VsMode to "VS MODU",
    WebStringKey.You to "Sen",
    WebStringKey.Points to "puan",
    WebStringKey.Streak to "Seri",
    WebStringKey.Accuracy to "Doğruluk",
    WebStringKey.MehrGuardBot to "Mehr Guard Bot",
    WebStringKey.Confidence to "Güven",
    WebStringKey.RoundAnalysis to "Tur Analizi",
    WebStringKey.Analysis to "Analiz",
    WebStringKey.CorrectDecision to "Doğru Karar!",
    WebStringKey.IdentifiedSafe to "Güvenli URL'yi doğru tanımladın",
    WebStringKey.AiNeuralAnalysis to "AI Sinir Ağı Analizi",
    WebStringKey.WhyBotFlagged to "Bot neden işaretledi",
    WebStringKey.EducationalNote to "Eğitim Notu",
    WebStringKey.Correct to "Doğru!",
    WebStringKey.SpottedPhishing to "Oltalama URL'sini doğru tespit ettin",
    WebStringKey.Response to "Yanıt",
    WebStringKey.NextRound to "Sonraki Tur",
    WebStringKey.GameOver to "Oyun Bitti!",
    WebStringKey.FinalResults to "Sonuçlar",
    WebStringKey.YourScore to "Senin Puanın",
    WebStringKey.BotScore to "Bot Puanı",
    WebStringKey.BestStreak to "En İyi Seri",
    WebStringKey.PlayAgain to "Tekrar Oyna",
    WebStringKey.ReturnToDashboard to "Panele Dön",
    WebStringKey.ExportSecurityReport to "Güvenlik Raporu Dışa Aktar",
    WebStringKey.GenerateReport to "Tam güvenlik raporu oluştur",
    WebStringKey.ReportFormat to "Rapor Formatı",
    WebStringKey.HumanReadable to "Okunabilir Rapor",
    WebStringKey.HumanReadableDesc to "Görsel analizli PDF",
    WebStringKey.MachineReadable to "Makine Okunabilir Veri",
    WebStringKey.MachineReadableDesc to "SIEM entegrasyonu için JSON",
    WebStringKey.DateRange to "Tarih Aralığı",
    WebStringKey.Last7Days to "Son 7 Gün",
    WebStringKey.Last30Days to "Son 30 Gün",
    WebStringKey.Last90Days to "Son 90 Gün",
    WebStringKey.AllTime to "Tümü",
    WebStringKey.CustomRange to "Özel Aralık",
    WebStringKey.ReportSections to "Rapor Bölümleri",
    WebStringKey.ExecutiveSummary to "Özet",
    WebStringKey.ThreatBreakdown to "Tehdit Analizi",
    WebStringKey.ScanTimeline to "Tarama Zaman Çizelgesi",
    WebStringKey.SafeUrlList to "Güvenli URL Listesi",
    WebStringKey.GenerateExport to "Raporu Dışa Aktar",
    WebStringKey.Success to "Başarılı!",
    WebStringKey.Error to "Hata",
    WebStringKey.Warning to "Uyarı",
    WebStringKey.CopiedToClipboard to "Panoya kopyalandı",
    WebStringKey.Cancel to "İptal",
    WebStringKey.Confirm to "Onayla",
    WebStringKey.Save to "Kaydet",
    WebStringKey.Delete to "Sil",
    WebStringKey.Edit to "Düzenle",
    WebStringKey.Close to "Kapat",
    WebStringKey.Back to "Geri",
    WebStringKey.Next to "İleri",
    WebStringKey.Previous to "Önceki",
    WebStringKey.Submit to "Gönder",
    WebStringKey.Reset to "Sıfırla",
    WebStringKey.Clear to "Temizle",
    WebStringKey.Search to "Ara",
    WebStringKey.Filter to "Filtrele",
    WebStringKey.Sort to "Sırala",
    WebStringKey.ToggleMenu to "Menü Aç/Kapat",
    WebStringKey.ToggleTheme to "Tema Değiştir",
    WebStringKey.Notifications to "Bildirimler",
    WebStringKey.Help to "Yardım",
    WebStringKey.Profile to "Profil",
    WebStringKey.ToggleLightDarkMode to "Açık/Koyu Mod",
    WebStringKey.UrlInputPlaceholder to "Analiz için URL yapıştır",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.Scan to "Tarama",
    WebStringKey.Result to "Sonuç",
    WebStringKey.ReportGeneration to "Rapor Oluşturma",
    WebStringKey.ReportGenerationDesc to "Formatı yapılandır ve indir",
    WebStringKey.OfflineSecurity to "Çevrimdışı Güvenlik",
    WebStringKey.OfflineSecurityDesc to "Veriler bu cihazdan çıkmaz",
    WebStringKey.ChooseFormat to "Format Seç",
    WebStringKey.PdfFormatDesc to "PDF formatı. Paylaşım için ideal",
    WebStringKey.JsonFormatDesc to "JSON formatı. SIEM için ideal",
    WebStringKey.Copy to "Kopyala",
    WebStringKey.LivePreview to "Canlı Önizleme",
    WebStringKey.ReadOnly to "Salt Okunur",
    WebStringKey.ThreatAnalysisReport to "Tehdit Analiz Raporu",
    WebStringKey.Verdict to "Karar",
    WebStringKey.RiskScore to "Risk Puanı",
    WebStringKey.TargetUrl to "Hedef URL",
    WebStringKey.AnalysisSummaryLabel to "Analiz Özeti",
    WebStringKey.TechnicalIndicators to "Teknik Göstergeler",
    WebStringKey.ExportInfoNote to "Tüm tehdit vektörleri dahil",
    WebStringKey.AllowList to "İzin Listesi",
    WebStringKey.BlockList to "Engel Listesi",
    WebStringKey.AddDomain to "Alan Adı Ekle",
    WebStringKey.RemoveDomain to "Alan Adını Kaldır",
    WebStringKey.TrustedDomains to "Güvenilir Alan Adları",
    WebStringKey.BlockedDomains to "Engellenmiş Alan Adları",
    WebStringKey.DomainPlaceholder to "Alan adı gir",
    WebStringKey.Safe to "Güvenli",
    WebStringKey.TimeAgo to "önce",
    WebStringKey.MinutesAgo to "dakika önce",
    WebStringKey.HoursAgo to "saat önce",
    WebStringKey.Critical to "KRİTİK",
    WebStringKey.Warn to "UYARI",
    WebStringKey.PhishingDetectionSensitivity to "Oltalama Tespit Hassasiyeti",
    WebStringKey.SensitivityDescription to "Sezgisel eşiği ayarla",
    WebStringKey.SensitivityLow to "Düşük",
    WebStringKey.SensitivityBalanced to "Dengeli",
    WebStringKey.SensitivityParanoia to "Paranoya",
    WebStringKey.BalancedModeRecommended to "Dengeli Mod (Önerilen)",
    WebStringKey.BalancedModeDesc to "Kötü amaçlı kalıpları tara",
    WebStringKey.LowSensitivityMode to "Düşük Hassasiyet Modu",
    WebStringKey.LowSensitivityModeDesc to "Yalnızca tehdit veritabanından bilinen kötü amaçlı URL'leri engeller. Minimum yanlış pozitif, ancak yeni saldırıları kaçırabilir.",
    WebStringKey.ParanoiaMode to "Paranoya Modu",
    WebStringKey.ParanoiaModeDesc to "Maksimum koruma. Yeni kayıtlı alan adları, yaygın olmayan TLD'ler ve potansiyel kodlama hileleri içeren tüm şüpheli kalıpları engeller.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard yerel sezgisel analiz motorları kullanır. Tarama sırasında hiçbir görüntü verisi, URL dizesi veya meta veri bu cihazdan ayrılmaz. Gizliliğiniz matematiksel olarak garanti edilir.",
    WebStringKey.SignalBrandImpersonation to "Potansiyel marka taklidi tespit edildi",
    WebStringKey.SignalCredentialParams to "URL'de kimlik bilgileriyle ilgili parametreler",
    WebStringKey.SignalEncodedPayload to "Sorgu parametrelerinde kodlanmış veri tespit edildi",
    WebStringKey.SignalExcessiveSubdomains to "Aşırı alt alan adı derinliği ({count} seviye)",
    WebStringKey.SignalHighEntropyHost to "Alan adında yüksek rastgelelik",
    WebStringKey.SignalHomographAttack to "Alan adı homograf/karıştırılabilir karakterler içeriyor",
    WebStringKey.SignalHttpNotHttps to "Güvenli olmayan HTTP protokolü kullanıyor",
    WebStringKey.SignalIpAddressHost to "Ana bilgisayar alan adı yerine IP adresi",
    WebStringKey.SignalLongUrl to "Olağandışı uzun URL ({length} karakter)",
    WebStringKey.SignalLongUrlMarketing to "Olağandışı uzun URL ({length} karakter) - pazarlama parametreleri içeriyor",
    WebStringKey.SignalNewlyRegisteredDomain to "Yeni kayıtlı alan adı tespit edildi",
    WebStringKey.SignalNonStandardPort to "Standart olmayan port: {port}",
    WebStringKey.SignalNumericSubdomain to "Yalnızca sayısal alt alan adı tespit edildi",
    WebStringKey.SignalSuspiciousPathKeywords to "Yolda şüpheli anahtar kelimeler ({count} bulundu)",
    WebStringKey.SignalSuspiciousTld to "Şüpheli TLD: {tld}",
    WebStringKey.SignalUrlShortener to "URL kısaltma servisi kullanıyor",
    WebStringKey.SecureEnvironment to "Güvenli Ortam",
    WebStringKey.LearnLocalArchitecture to "Yerel mimari hakkında bilgi",
    WebStringKey.NoCustomDomainsBlocked to "Engellenen özel alan adı yok",
    WebStringKey.AddManually to "Manuel ekle",
    WebStringKey.AddedDaysAgo to "2 gün önce eklendi",
    WebStringKey.AddedWeekAgo to "1 hafta önce eklendi",
    WebStringKey.PrivacyControls to "Gizlilik Kontrolleri",
    WebStringKey.StrictOfflineMode to "Katı Çevrimdışı Mod",
    WebStringKey.DisableExternalPreviews to "Harici önizlemeleri devre dışı bırak",
    WebStringKey.AnonymousTelemetry to "Anonim Telemetri",
    WebStringKey.ShareDetectionStats to "Tespit istatistiklerini paylaş",
    WebStringKey.AutoCopySafeLinks to "Güvenli bağlantıları otomatik kopyala",
    WebStringKey.CopyTrustedUrls to "Güvenilir URL'leri kopyala",
    WebStringKey.AboutMehrGuard to "Mehr Guard Hakkında",
    WebStringKey.OpenSourceLicenses to "Açık Kaynak Lisansları",
    WebStringKey.PrivacyPolicy to "Gizlilik Politikası",
    WebStringKey.Acknowledgements to "Teşekkürler",
    WebStringKey.ResetAllSettings to "Tüm Ayarları Sıfırla",
    WebStringKey.AddToAllowlist to "İzin Listesine Ekle",
    WebStringKey.AddToBlocklist to "Engel Listesine Ekle",
    WebStringKey.AnalysedOfflineTitle to "Çevrimdışı Analiz",
    WebStringKey.YourDataStaysOnDevice to "Veriler cihazda kalır",
    WebStringKey.OnboardingHeroDesc to "Güvenli cihaz üzeri analiz",
    WebStringKey.OnDeviceAnalysis to "Cihaz Üzeri Analiz",
    WebStringKey.OnDeviceAnalysisDesc to "Tüm tehdit tespiti yerel çalışır",
    WebStringKey.NoCloudLogs to "Bulut Kaydı Yok",
    WebStringKey.NoCloudLogsDesc to "Giden telemetri devre dışı",
    WebStringKey.OnDeviceDB to "Cihaz Üzeri DB",
    WebStringKey.OnDeviceDBDesc to "Tam tehdit imza DB'si",
    WebStringKey.DataLifecycleVerification to "Veri Yaşam Döngüsü Doğrulama",
    WebStringKey.SecurityAuditPass to "Güvenlik Denetimi: GEÇTİ",
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc.",
    WebStringKey.Support to "Destek",
    WebStringKey.Terms to "Koşullar",
    WebStringKey.SystemsOperational to "Sistemler Çalışıyor",
    WebStringKey.SystemSecure to "Sistem Güvenli",
    WebStringKey.VersionStatus to "v2.4.1 • Sistem Güvenli",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Mehr Guard Enterprise tarafından doğrulandı",
    WebStringKey.SampleUserName to "Ahmet Yılmaz",
    WebStringKey.SampleUserRole to "Güvenlik Analisti",
    WebStringKey.DetailLabel to "Detay Etiketi",
    WebStringKey.DetailValue to "Detay Değeri",
    WebStringKey.Suspicious to "Şüpheli",
    WebStringKey.IncorrectDecision to "Yanlış Karar",
    WebStringKey.WrongAnswer to "Eyvah! Yanlış",
    WebStringKey.ResponseTime to "Yanıt Süresi",
    WebStringKey.IncomingMessage to "Gelen Mesaj",
    WebStringKey.CertificateIssuer to "Sertifika veren eşleşti",
    WebStringKey.DomainAgeTrust to "Alan yaşı > 5 yıl",
    WebStringKey.WhitelistedRank to "Alexa top 1k",
    WebStringKey.GameEducationalNote to "Eğitim Notu",
    WebStringKey.GameHintTitle to "Oyun İpucu",
    WebStringKey.AddToAllowlistTitle to "İzin Listesine Ekle",
    WebStringKey.AddToBlocklistTitle to "Engel Listesine Ekle",
    WebStringKey.EnterDomainPrompt to "Alan adı gir",
    WebStringKey.LatencyMs to "Gecikme",
    WebStringKey.StreakFire to "Seri",
    WebStringKey.AccuracyPercent to "Doğruluk",
    WebStringKey.ConfidencePercent to "Güven",
    WebStringKey.English to "İngilizce",
    WebStringKey.German to "Almanca",
    WebStringKey.Spanish to "İspanyolca",
    WebStringKey.French to "Fransızca",
    WebStringKey.ChineseSimplified to "Çince (Basit)",
    WebStringKey.Japanese to "Japonca",
    WebStringKey.Hindi to "Hintçe",
    WebStringKey.Arabic to "Arapça",
    WebStringKey.Indonesian to "Endonezce",
    WebStringKey.Italian to "İtalyanca",
    WebStringKey.Korean to "Korece",
    WebStringKey.Portuguese to "Portekizce",
    WebStringKey.Russian to "Rusça",
    WebStringKey.Thai to "Tayca",
    WebStringKey.Turkish to "Türkçe",
    WebStringKey.Vietnamese to "Vietnamca"
,
    WebStringKey.ComponentVoting to "Bileşen Oylaması",
    WebStringKey.Heuristic to "Sezgisel",
    WebStringKey.MLModel to "ML Modeli",
    WebStringKey.Brand to "Marka",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Çoğunluk oyu kararı belirler: 3+ GÜVENLİ = yeşil, 2+ ZARARLI = kırmızı"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Tarama bekleniyor...",
    WebStringKey.WaitingForAnalysis to "Analiz bekleniyor...",
    WebStringKey.ScanURLToSeeResults to "Detaylı sonuçları görmek için URL tarayın.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Klavye Kısayolları",
    WebStringKey.StartScanner to "Tarayıcıyı Başlat",
    WebStringKey.CloseMenuModal to "Menüyü / Pencereyi Kapat",
    WebStringKey.NavigateToDashboard to "Gösterge Paneline Git",
    WebStringKey.NavigateToHistory to "Tarama Geçmişi",
    WebStringKey.NavigateToTrust to "Güven Merkezi / İzin Listesi",
    WebStringKey.NavigateToGame to "Botu Yen Oyunu",
    WebStringKey.ShowHelp to "Yardımı Göster",
    WebStringKey.GotIt to "Anladım",
    WebStringKey.SecuritySettings to "Güvenlik Ayarları",
    WebStringKey.SensitivityLevel to "Hassasiyet Seviyesi",
    WebStringKey.AutoBlockThreats to "Tehditleri Otomatik Engelle",
    WebStringKey.RealTimeScanning to "Gerçek Zamanlı Tarama",
    WebStringKey.SoundAlerts to "Sesli Uyarılar",
    WebStringKey.ThreatAlerts to "Tehdit Uyarıları",
    WebStringKey.ShowConfidenceScore to "Güven Puanını Göster",
    WebStringKey.CompactView to "Kompakt Görünüm",
    WebStringKey.ResetDefaults to "Varsayılanlara Sıfırla",
    WebStringKey.SaveAndContinue to "Kaydet ve Devam Et",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "ŞÜPHELİ AKTİVİTE",
    WebStringKey.VerdictWarning to "Uyarı",
    WebStringKey.VerdictSuspiciousDesc to "Taranan QR kod, potansiyel güvenlik risklerine işaret edebilecek şüpheli kalıplar gösteriyor. Dikkatli ilerleyin.",
    WebStringKey.VerdictMinorConcerns to "KÜÇÜK ENDIŞELER",
    WebStringKey.VerdictCaution to "Dikkat",
    WebStringKey.VerdictMinorConcernsDesc to "Bazı küçük güvenlik endişeleri belirlendi. Bağlantı çoğunlukla güvenli görünüyor ancak inceleme önerilir.",
    WebStringKey.VerdictVerifiedSafe to "DOĞRULANMIŞ GÜVENLİ",
    WebStringKey.VerdictSafeLabel to "Güvenli",
    WebStringKey.VerdictVerifiedSafeDesc to "Güvenlik tehdidi tespit edilmedi. QR kod doğrulanmış güvenli bir hedefe yönlendiriyor.",
    WebStringKey.VerdictNoActivity to "Aktivite Yok",
    WebStringKey.VerdictAwaitingScan to "Tarama Bekleniyor",
    WebStringKey.VerdictNoActivityDesc to "Tarama verisi mevcut değil. Lütfen bir QR kod tarayın veya analiz için URL girin.",
    WebStringKey.ScanQrToSeeActivity to "Aktivitenizi görmek için QR kod tarayın",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Veri Noktası",
    WebStringKey.ProcessingEnv to "İşleme Ortamı",
    WebStringKey.ExternalTransmission to "Harici İletim",
    WebStringKey.RawImageBuffer to "Ham Görüntü Arabelleği",
    WebStringKey.LocalMemoryRam to "Yerel Bellek (RAM)",
    WebStringKey.TransmissionNone to "Yok",
    WebStringKey.DecodedUrlPayload to "Çözülmüş URL/Yük",
    WebStringKey.LocalAnalysis to "Yerel Analiz",
    WebStringKey.ThreatVerdictLabel to "Tehdit Kararı",
    WebStringKey.LocalDatabase to "Yerel Veritabanı",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Mehr Guard Security Hakkında",
    WebStringKey.ActualDomain to "Gerçek Alan Adı",
    WebStringKey.AnalysisComplete to "Analiz Tamamlandı",
    WebStringKey.AutoBlockThreatsDesc to "Tehditleri otomatik engelle",
    WebStringKey.AwaitingScanLabel to "Tarama Bekleniyor",
    WebStringKey.BrandImpersonation to "Marka Taklidi",
    WebStringKey.CautionAdvised to "Dikkat Önerilir",
    WebStringKey.CompactViewDesc to "Kompakt Görünüm",
    WebStringKey.DoNotVisit to "ZİYARET ETMEYİN",
    WebStringKey.DoNotVisitDesc to "Yüksek güvenilirlikli oltalama tespit edildi. Bu URL birden fazla kötü amaçlı gösterge sergiliyor.",
    WebStringKey.DomainUsesInternationalChars to "Bu alan adı, meşru alan adlarını taklit edebilecek uluslararası karakterler kullanıyor.",
    WebStringKey.GoToScanner to "Tarayıcıya Git",
    WebStringKey.Hebrew to "İbranice",
    WebStringKey.HelpKeyboardShortcuts to "Klavye Kısayolları",
    WebStringKey.HeuristicAnalysis to "Sezgisel Analiz",
    WebStringKey.HeuristicAnalysisDesc to "URL, analiz motoru tarafından tespit edilen birden fazla risk faktörüne göre işaretlendi.",
    WebStringKey.HiddenDestination to "Gizli Hedef",
    WebStringKey.HighRisk to "Yüksek Risk",
    WebStringKey.HighRiskLabel to "YÜKSEK RİSK",
    WebStringKey.HomographIdnAttack to "Homograf / IDN Saldırısı",
    WebStringKey.InternationalizedDomainDetected to "Uluslararası alan adı tespit edildi.",
    WebStringKey.JustNow to "Az önce",
    WebStringKey.KeyboardShortcutsDesc to "Hızlı erişim için klavye kısayolları",
    WebStringKey.LiveFeedActive to "CANLI YAYIN AKTİF",
    WebStringKey.LowRisk to "Düşük Risk",
    WebStringKey.LowRiskLabel to "DÜŞÜK RİSK",
    WebStringKey.Malicious to "Kötü Amaçlı",
    WebStringKey.MediumRiskLabel to "ORTA RİSK",
    WebStringKey.NoData to "VERİ YOK",
    WebStringKey.NoScanDataResults to "Tarama verisi mevcut değil. Analiz sonuçlarını görmek için lütfen bir URL tarayın.",
    WebStringKey.NoUrlScanned to "URL taranmadı",
    WebStringKey.Persian to "Farsça",
    WebStringKey.PhishingIndicators to "Oltalama Göstergeleri",
    WebStringKey.ProceedWithCaution to "DİKKATLİ İLERLEYİN",
    WebStringKey.ProceedWithCautionDesc to "Bazı şüpheli göstergeler tespit edildi. Hassas bilgi girmeden önce kaynağı doğrulayın.",
    WebStringKey.RealTimeScanningDesc to "Gerçek zamanlı tarama",
    WebStringKey.RedirectShortenerDetected to "Yönlendirme/Kısaltma Tespit Edildi",
    WebStringKey.SafeToVisit to "ZİYARET İÇİN GÜVENLİ",
    WebStringKey.SafeToVisitDesc to "Yerel sezgisel v2.4 tarafından doğrulandı. Oltalama deseni, gizlenmiş betik veya kara liste eşleşmesi bulunamadı.",
    WebStringKey.SafetyScore to "Güvenlik Puanı",
    WebStringKey.ScanCompleteLabel to "Tarama Tamamlandı",
    WebStringKey.ScanToAnalyze to "Analiz için QR kodu tarayın veya URL girin.",
    WebStringKey.ScannedURLLabel to "Taranan URL",
    WebStringKey.SecuritySignal to "Güvenlik Sinyali",
    WebStringKey.SensitivityLevelDesc to "Hassasiyet Seviyesi",
    WebStringKey.SensitivityPermissive to "İzin Verici",
    WebStringKey.SensitivityStrict to "Katı",
    WebStringKey.SettingsDetection to "Algılama",
    WebStringKey.SettingsDisplay to "Görüntüleme",
    WebStringKey.SettingsLanguage to "Dil",
    WebStringKey.SettingsLanguageDesc to "Arayüz dilini seçin",
    WebStringKey.SettingsNotifications to "Bildirimler",
    WebStringKey.SettingsSavedAutomatically to "Ayarlar otomatik olarak kaydedilir ve oturumlar arasında senkronize edilir.",
    WebStringKey.ShowConfidenceScoreDesc to "Güven puanını göster",
    WebStringKey.SoundAlertsDesc to "Sesli uyarılar",
    WebStringKey.SuspiciousDomain to "Şüpheli Alan Adı",
    WebStringKey.SuspiciousEncoding to "Şüpheli Kodlama",
    WebStringKey.SuspiciousKeywords to "Şüpheli Anahtar Kelimeler",
    WebStringKey.SuspiciousTld to "Şüpheli TLD",
    WebStringKey.SuspiciousTldDesc to "Alan adı, genellikle kötü amaçlı sitelerle ilişkilendirilen {tld} TLD kullanıyor.",
    WebStringKey.SuspiciousUrlParams to "Şüpheli URL Parametreleri",
    WebStringKey.SuspiciousUrlParamsDesc to "URL karmaşık veya potansiyel olarak gizlenmiş parametreler içeriyor.",
    WebStringKey.ThreatAlertsDesc to "Tehdit uyarıları",
    WebStringKey.ThreatDetected to "Tehdit Tespit Edildi",
    WebStringKey.UnableToDetermine to "Karar belirlenemiyor. Lütfen tekrar deneyin.",
    WebStringKey.Unknown to "Bilinmiyor",
    WebStringKey.UnknownURL to "Bilinmeyen URL",
    WebStringKey.UrlShortenerDesc to "URL, son hedefi gizleyen bir kısaltma hizmeti kullanıyor.",
    WebStringKey.UrlShortenerDetected to "URL Kısaltma Tespit Edildi",
    WebStringKey.VersionOfflineReady to "Çevrimdışı hazır",
    WebStringKey.VisualAppearance to "Görsel Görünüm",
    WebStringKey.WaitingForAnalysisLabel to "Analiz bekleniyor...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "JavaScript URL şeması tespit edildi - tıklandığında kod çalıştırır",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "Data URI şeması tespit edildi - gömülü kötü amaçlı kod içerebilir",
    WebStringKey.ReasonAtSymbolInjectionTitle to "@ Sembolü Enjeksiyonu",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL, olası kimlik bilgisi hırsızlığı girişimini gösteren @ sembolü içeriyor",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Homograf Saldırısı",
    WebStringKey.ReasonHomographDesc to "Uluslararası alan adı (IDN) başka bir alanı taklit edebilir",
    WebStringKey.ReasonMixedScriptTitle to "Karışık Script",
    WebStringKey.ReasonMixedScriptDesc to "Ana bilgisayar adı birden fazla script'ten karakterler içeriyor (olası sahtekarlık)",
    WebStringKey.ReasonLookalikeCharsTitle to "Benzer Karakterler",
    WebStringKey.ReasonLookalikeCharsDesc to "Alan adı ASCII harflere benzeyen Unicode karakterler içeriyor",
    WebStringKey.ReasonZeroWidthCharsTitle to "Sıfır Genişlikli Karakterler",
    WebStringKey.ReasonZeroWidthCharsDesc to "Gizli sıfır genişlikli Unicode karakterler tespit edildi (gizleme girişimi)",
    WebStringKey.ReasonIpHostTitle to "IP Sunucusu",
    WebStringKey.ReasonIpHostDesc to "URL, alan adı yerine IP adresi kullanıyor",
    WebStringKey.ReasonCredentialParamTitle to "Kimlik Bilgisi Parametresi",
    WebStringKey.ReasonCredentialParamDesc to "URL, kimlik bilgileriyle ilgili parametreler içeriyor (şifre, token vb.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Marka Taklidi",
    WebStringKey.ReasonBrandImpersonationDesc to "URL, bilinen bir markayı taklit ediyor gibi görünüyor",
    WebStringKey.ReasonBrandInSubdomainTitle to "Alt Alan Adında Marka",
    WebStringKey.ReasonBrandInSubdomainDesc to "Marka adı alt alan adında görünüyor ancak ana alan adında değil",
    WebStringKey.ReasonRiskyExtensionTitle to "Riskli Uzantı",
    WebStringKey.ReasonRiskyExtensionDesc to "Yol, potansiyel olarak tehlikeli dosya uzantısı içeriyor",
    WebStringKey.ReasonDoubleExtensionTitle to "Çift Uzantı",
    WebStringKey.ReasonDoubleExtensionDesc to "Çift dosya uzantısı tespit edildi (yaygın kötü amaçlı yazılım taktiği)",
    WebStringKey.ReasonEncodedPayloadTitle to "Kodlanmış Yük",
    WebStringKey.ReasonEncodedPayloadDesc to "URL parametrelerinde büyük kodlanmış veri tespit edildi",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP, HTTPS Değil",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL, HTTPS yerine güvensiz HTTP protokolü kullanıyor",
    WebStringKey.ReasonSuspiciousTldTitle to "Şüpheli TLD",
    WebStringKey.ReasonSuspiciousTldDesc to "Üst düzey alan adı sıklıkla kimlik avı için kullanılıyor",
    WebStringKey.ReasonHighEntropyHostTitle to "Yüksek Entropi Sunucusu",
    WebStringKey.ReasonHighEntropyHostDesc to "Alan adı rastgele oluşturulmuş gibi görünüyor",
    WebStringKey.ReasonRedirectParamTitle to "Yönlendirme Parametresi",
    WebStringKey.ReasonRedirectParamDesc to "URL, başka bir siteye yönlendirebilecek yönlendirme parametresi içeriyor",
    WebStringKey.ReasonDeepSubdomainTitle to "Derin Alt Alan Adı",
    WebStringKey.ReasonDeepSubdomainDesc to "Aşırı alt alan adı derinliği (gerçek alanı gizleyebilir)",
    WebStringKey.ReasonMultiTldTitle to "Çoklu TLD",
    WebStringKey.ReasonMultiTldDesc to "Alan adında TLD benzeri birden fazla bölüm",
    WebStringKey.ReasonNumericSubdomainTitle to "Sayısal Alt Alan Adı",
    WebStringKey.ReasonNumericSubdomainDesc to "Yalnızca sayısal alt alan adı tespit edildi",
    WebStringKey.ReasonNonStandardPortTitle to "Standart Dışı Port",
    WebStringKey.ReasonNonStandardPortDesc to "URL standart dışı port numarası kullanıyor",
    WebStringKey.ReasonSuspiciousPortTitle to "Şüpheli Port",
    WebStringKey.ReasonSuspiciousPortDesc to "URL genellikle saldırılarla ilişkilendirilen port kullanıyor",
    WebStringKey.ReasonFragmentHidingTitle to "Fragment Gizleme",
    WebStringKey.ReasonFragmentHidingDesc to "URL fragment'ı ek içerik gizliyor gibi görünüyor",
    WebStringKey.ReasonExcessiveEncodingTitle to "Aşırı Kodlama",
    WebStringKey.ReasonExcessiveEncodingDesc to "Aşırı URL kodlaması tespit edildi (gizleme girişimi)",
    WebStringKey.ReasonDomainAgePatternTitle to "Alan Adı Yaş Deseni",
    WebStringKey.ReasonDomainAgePatternDesc to "Alan adı otomatik oluşturulan alan adlarının desenlerine uyuyor",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "URL Kısaltıcı",
    WebStringKey.ReasonUrlShortenerDesc to "URL kısaltma hizmeti kullanıyor (gerçek hedefi gizliyor)",
    WebStringKey.ReasonSuspiciousPathTitle to "Şüpheli Yol",
    WebStringKey.ReasonSuspiciousPathDesc to "Yol şüpheli anahtar kelimeler içeriyor (login, verify vb.)",
    WebStringKey.ReasonLongUrlTitle to "Uzun URL",
    WebStringKey.ReasonLongUrlDesc to "Alışılmadık şekilde uzun URL",
    WebStringKey.ReasonCredentialKeywordsTitle to "Kimlik Bilgisi Anahtar Kelimeleri",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL, kimlik bilgisi toplama anahtar kelimeleri içeriyor",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "Ayrıştırılamayan URL",
    WebStringKey.ReasonUnparseableDesc to "URL tamamen ayrıştırılamadı",
    WebStringKey.ReasonAnalysisCompleteTitle to "Analiz Tamamlandı",
    WebStringKey.ReasonAnalysisCompleteDesc to "Analiz başarıyla tamamlandı",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "ML Kimlik Avı Puanı",
    WebStringKey.MlCharacterAnalysis to "Karakter analizi",
    WebStringKey.MlFeatureAnalysis to "Özellik analizi",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycode Alan Adı",
    WebStringKey.IdnPunycodeDomainDesc to "Bu alan adı uluslararası karakterler kullanıyor. Güvenli görüntüleme:",
    WebStringKey.MixedScriptAttackTitle to "Karışık Script Saldırısı",
    WebStringKey.MixedScriptAttackDesc to "Alan adı birden fazla yazı sisteminden karakterler içeriyor (örn. Kiril + Latin). Homograf saldırılarında yaygın.",
    WebStringKey.ConfusableCharsTitle to "Karıştırılabilir Karakterler",
    WebStringKey.ConfusableCharsDesc to "Alan adı yaygın harflere benzeyen karakterler içeriyor (örn. 'а' vs 'a')."
)

internal val TurkishCommonStrings = mapOf(
    "Engine Active" to "Motor Aktif",
    "Enterprise Protection Active" to "Kurumsal Koruma Aktif",
    "Secure. Offline.\nExplainable Defence." to "Güvenli. Çevrimdışı.\nAçıklanabilir Savunma.",
    "Start New Scan" to "Yeni Tarama Başlat",
    "Import Image" to "Görsel İçe Aktar",
    "System Health" to "Sistem Durumu",
    "Threat Database" to "Tehdit Veritabanı",
    "Current" to "Güncel",
    "Heuristic Engine" to "Sezgisel Motor",
    "Active" to "Aktif",
    "Threats" to "Tehditler",
    "Safe Scans" to "Güvenli Taramalar",
    "Offline-First Architecture" to "Çevrimdışı Öncelikli Mimari",
    "Explainable Security" to "Açıklanabilir Güvenlik",
    "High-Performance Engine" to "Yüksek Performanslı Motor",
    "Recent Scans" to "Son Taramalar",
    "View Full History" to "Tam Geçmişi Görüntüle",
    "Status" to "Durum",
    "Source" to "Kaynak",
    "Details" to "Ayrıntılar",
    "Time" to "Zaman",
    "SAFE" to "GÜVENLİ",
    "SUSPICIOUS" to "ŞÜPHELİ",
    "PHISHING" to "OLTALAMA",
    "UNKNOWN" to "BİLİNMEYEN",
    "Trusted Domain" to "Güvenilir Alan Adı",
    "Version" to "Sürüm",
    "Last Update" to "Son Güncelleme",
    "Signatures" to "İmzalar",
    "Check for Updates" to "Güncellemeleri Kontrol Et",
    "WAITING FOR INPUT" to "GİRİŞ BEKLENİYOR",
    "SCANNING" to "TARANIYOR",
    "ANALYZING" to "ANALİZ EDİLİYOR",
    "ERROR" to "HATA",
    "SCAN COMPLETE" to "TARAMA TAMAMLANDI",
    "Active Scanner" to "Aktif Tarayıcı",
    "Mode:" to "Mod:",
    "Offline First" to "Önce Çevrimdışı",
    "Enable Camera" to "Kamerayı Etkinleştir",
    "Torch" to "El Feneri",
    "Upload Image" to "Görsel Yükle",
    "Paste URL" to "URL Yapıştır",
    "SYSTEM STATUS" to "SİSTEM DURUMU",
    "Detection Engine" to "Tespit Motoru",
    "Phishing Guard" to "Oltalama Koruması",
    "READY" to "HAZIR",
    "Database" to "Veritabanı",
    "LATEST" to "EN YENİ",
    "Latency" to "Gecikme",
    "RECENT SCANS" to "SON TARAMALAR",
    "View All" to "Tümünü Görüntüle",
    "No scans yet" to "Henüz tarama yok",
    "Export Log" to "Günlüğü Dışa Aktar",
    "Scan History" to "Tarama Geçmişi",
    "Safe" to "Güvenli",
    "Suspicious" to "Şüpheli",
    "Dangerous" to "Tehlikeli",
    "Risk" to "Risk",
    "Verdict" to "Karar",
    "Actions" to "İşlemler",
    "Scan" to "Tarama",
    "Results" to "Sonuçlar",
    "ENGINE ACTIVE" to "MOTOR AKTİF",
    "Safe to Visit" to "Ziyaret Etmek Güvenli",
    "Confidence" to "Güven",
    "Scan Time" to "Tarama Süresi",
    "Engine" to "Motor",
    "Visit URL" to "URL'yi Ziyaret Et",
    "Copy Safe Link" to "Güvenli Bağlantıyı Kopyala",
    "Export Report" to "Raporu Dışa Aktar",
    "Dashboard" to "Gösterge Paneli",
    "Mehr Guard" to "Mehr Guard",
    "Settings" to "Ayarlar",
    "Language" to "Dil",
    "Training Centre" to "Eğitim Merkezi",
    "Analyze" to "Analiz Et"
)
